<template>
  <page-layout-full class="ai-widget-view" view="sm">
    <template #title> Тест готового виджета Яндекса </template>

    <template #subtitle>
      Страница-подложка под встраиваемый виджет Яндекса (Нейросаппорт). Виджет
      подключается своим скриптом, весь диалог обрабатывается на стороне
      Яндекса.
    </template>

    <base-alert v-if="!src" view="warning">
      Скрипт виджета не задан. Яндекс выдаёт его после заявки на
      <a href="https://neurosupport.yandex.ru/" rel="nofollow" target="_blank">
        neurosupport.yandex.ru </a
      >: самостоятельного подключения у сервиса нет. Полученный адрес скрипта
      нужно положить в переменную VUE_APP_YANDEX_AI_WIDGET_SRC.
    </base-alert>

    <div id="yandex-ai-widget" class="ai-widget-view__container">
      <p v-if="!src" class="ai-widget-view__placeholder">
        Здесь появится виджет
      </p>
    </div>
  </page-layout-full>
</template>

<script>
import PageLayoutFull from "@/components/page/PageLayoutFull.vue";
import BaseAlert from "@/components/shared/BaseAlert.vue";

export default {
  components: {
    PageLayoutFull,
    BaseAlert,
  },
  data() {
    return {
      src: process.env.VUE_APP_YANDEX_AI_WIDGET_SRC || "",
      scriptId: "yandex-ai-widget-script",
    };
  },
  mounted() {
    this.onLoadWidget();
  },
  beforeDestroy() {
    const script = document.getElementById(this.scriptId);
    if (script) script.remove();
  },
  methods: {
    onLoadWidget() {
      if (!this.src || document.getElementById(this.scriptId)) return;

      const script = document.createElement("script");
      script.id = this.scriptId;
      script.src = this.src;
      script.async = true;
      script.onerror = () => {
        this.$toast.error("Не удалось загрузить скрипт виджета.");
      };

      document.body.appendChild(script);
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-widget-view {
  &__container {
    border: 1px dashed $grey-300;
    border-radius: 8px;
    min-height: 460px;
    padding: 1rem;
    position: relative;
  }

  &__placeholder {
    color: $stone;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
